import { render, staticRenderFns } from "./RealtimgData.vue?vue&type=template&id=16ea87b2&scoped=true"
import script from "./RealtimgData.vue?vue&type=script&lang=js"
export * from "./RealtimgData.vue?vue&type=script&lang=js"
import style0 from "./RealtimgData.vue?vue&type=style&index=0&id=16ea87b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ea87b2",
  null
  
)

export default component.exports